<template>
	<div>
	<div class="boxshow" :class="{'sticky': isSticky}" ref="searchRef">
		<div class="experts flex-1 pad-16 jus-bet" 
			:class="{'mt': this.$route.fullPath=='/personal/collect/index'||this.$route.fullPath=='/personal/unlockedExperts'}">
			<div class="flex-1 jus-bet">
				<div class="left-icon"></div>
				<p>{{titles}}</p>

			</div>
			<div class="flex-1">
				<div class="flex-1 jus-bet cursor" @click="checks">
					<img src="../assets/expert/shaixuan.png" alt="" style="width: 16px;height: 16px;">
					<p style="font-size: 14px">
						<span v-if="hasFilter==false">筛选</span>
						<span v-if="hasFilter" class="color-red">已有筛选</span>
					</p>
				</div>
				<div class="flex-1 jus-bet cursor" @click="collet(1)"
					v-show="this.$route.fullPath=='/personal/collect/index'||this.$route.fullPath=='/collect/index'"
					style="padding-left: 3rem;">
					<img :src="!isShow1 ? img1 : img2" alt="" style="width: 16px;height: 16px;">
					<p style="font-size: 14px;" :class="!isShow1?'colet-1':'colet'">{{!isShow1?'收藏管理':'取消收藏'}}
					</p>
				</div>
			</div>
		</div>
		<div class="check pad-16" v-show="shows1">
			<div class="all-check">
				<div class="check-1">
					<p class="check-p">省份({{num}})</p>
					<div class="check-1-p">
						<p :class="showAllSelected?'selected':'delAll'" @click="checkAll">全部</p>
						<p v-for="(ite,inde) in proviceList" :key="inde" @click="proClick(inde)"
							:class="ite.checked?'selected':'delAll'">
							<!-- :class="ite.checked?'selected':'delAll'" -->
							<!-- :class="current == inde ?'selected':'delAll'" -->
							{{ite.provinceName}}
						</p>
					</div>
				</div>
				<div class="check-1">
					<p class="check-p">学科({{offlNo}})</p>
					<div class="check-1-p">
						<p :class="officlShow?'selected':'delAll'" @click="officlCheckAll">全部</p>
						<p v-for="(ite,inde) in officl" :key="inde" @click="offClick(inde)"
							:class="ite.checked?'selected':'delAll'">
							{{ite.name}}
						</p>
					</div>
				</div>
				<div class="check-1">
					<p class="check-p">专家类型({{schoolNo}})</p>
					<div class="check-1-p">
						<p :class="schoolShow?'selected':'delAll'" @click="schoCheckAll">全部</p>
						<p v-for="(ite,inde) in school" :key="inde" @click="schoClick(ite.name,inde)"
							:class="ite.checked?'selected':'delAll'">
							{{ite.name}}
						</p>
					</div>
				</div>
				<div class="check-1">
					<p class="check-p">擅长领域({{goodlNo}})</p>
					<div class="check-1-p">
						<p :class="goodShow?'selected':'delAll'" @click="goodCheckAll">全部</p>
						<p v-for="(ite,inde) in goodat" :key="inde" @click="goodClick(inde)"
							:class="ite.checked?'selected':'delAll'">
							{{ite.name}}
							<!-- <span v-if="inde<goodat.length-1">、</span> -->
						</p>
					</div>
				</div>
				<div class="check-1" v-if="userList.userLevelStatus">
					<p class="check-p">课酬/半天({{moneyNo}})</p>
					<div class="check-1-p">
						<p :class="moneyShow?'selected':'delAll'" @click="moneyCheckAll">全部</p>
						<p v-for="(ite,inde) in money" :key="inde" @click="moneyClick(inde)"
							:class="ite.checked?'selected':'delAll'">
							{{ite.name}}
						</p>
					</div>
				</div>
				<div class="check-1 jus-bet">
					<div class="check-1">
						<p class="check-p">是否公益({{isNum}})</p>
						<div class="check-1-p">
							<p :class="isNoShow?'selected':'delAll'" @click="isNoCheckAll">全部</p>
							<p v-for="(ite,inde) in isNo" :key="inde" @click="isNoClick(inde)"
								:class="isIndex == inde ?'selected':'delAll'">
								{{ite.name}}
							</p>
						</div>
					</div>
					<div class="check-1 align-1 cursor" @click="again">
						<img src="../assets/expert/chongzhi.png" alt="" style="width: 16px;height: 16px;">
						<p style="margin: 0;">重置</p>
					</div>
				</div>
				<div class="shouqi cursor" @click="shou">
					<el-button style="background-color: #409EFF;color: #fff;">收起<i class="el-icon-arrow-up" style="font-size: 18px;font-weight: 500;"></i></el-button>
					<!-- <span>收起</span>
					<i class="el-icon-arrow-up" style="font-size: 18px;font-weight: 500;"></i> -->
				</div>
			</div>
		</div>
		<div class="search-2 " v-show="this.$route.fullPath =='/expert/wisdom'">
			<div class="search-3">
				<el-select v-model="value" placeholder="姓名" class="place" @change="selectChange"
					style="border-right: 1px solid #EFEFEF;">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<el-input v-model="selectName" placeholder="请输入搜索内容" class="elinput" @change="hancleClick">
				</el-input>
				<el-button type="primary" @click="getInit(0)">搜索</el-button>
			</div>
		</div>
	</div>
	<div class="pad-16 col-22">
		<div
			:class="{ 'clool-2':!isShow1, 'clool cursor':item.checked,'clool-1 cursor': isShow1 && !item.checked }"
			style="margin-bottom: 24px;display: flex;" v-for="(item,index1) in expertList" :key="index1"
			@click="expertDetail(item.id,index1,nums)">
			<img :src="item.checked ? img4 : img3" alt="" style="width: 18px;height: 18px;padding-right: 16px;"
				v-show="isShow1">
			<!-- <img :src="item.checked == false ? img4 : img3" alt=""  style="width: 18px;height: 18px;padding-right: 16px;" v-show="isShow1"> -->
			<!-- <img :src="img4" alt=""> -->
			<img :src="item.avatar" alt="" class="hed-img">
			<div class="flex-1 jus-bet" style="width: 85%;">
				<div style="padding-right: 16px;">
					<div class="flex-1 mb-8">
						<p class="name-1">{{item.name}}</p>
						<img :src="item.gender==1?imgNan:imgNv" alt="" class="sex-img">
						<!-- <img src="../assets/expert/nv.png" alt="">
						<img src="../assets/expert/nan.png" alt=""> -->
					</div>
					<div class="flex-1 mb-8">
						<p class="name-2">工作单位:</p>
						<p class="name-3">{{ item.company }}</p>
					</div>
					<div class="flex-1 mb-8">
						<p class="name-2">擅长领域:</p>
						<div style="display: flex;flex-wrap: wrap;">
							<p style="white-space:nowrap;" class="name-3" v-for="(ite1,inde1) in item.fieldList" :key="inde1">{{ite1.name}}<span v-if="inde1<item.fieldList.length-1">、</span></p><span style="white-space:nowrap;" class="name-3" v-if="item.fieldInfo">、</span><span style="white-space:nowrap;" class="name-3" v-if="item.fieldInfo">{{item.fieldInfo}}</span>
						</div>
					</div>
					<div class="flex-1" style="align-items: baseline;">
						<p class="name-2">专家简介:</p>
						<p class="name-3" v-html="SString.sstrim(item.moduleContent, 100)">
							{{item.moduleContent}}
						</p>
					</div>
				</div>
				<div class="online" @click="lixnai(item)">
					联系专家
				</div>
			</div>
		</div>
		<el-empty description="暂无专家列表" v-if="expertList.length == 0"></el-empty>
		<el-pagination v-show="pageInline.tableTotal>0" @size-change="handleSizeChange"
			@current-change="handleCurrentChange" :page-sizes="pageGroup.sizes" :page-size="pageGroup.size"
			layout="total, sizes, prev, pager, next, jumper" :total="pageInline.tableTotal">
		</el-pagination>
		<!-- 全选 -->
		<div class="checkall flex-1 jus-bet" v-show="isShow1">
			<div class="quanxuan flex-1 cursor" @click="scCheckAll()">
				<img :src="showsAll ? img4 : img3" alt="" style="width: 18px;height: 18px;padding-right: 12px;">

				<!--      <img :src="!isShow2 ? img3 : showAllSelected ? img4 : img3 " alt=""
						style="width: 18px;height: 18px;padding-right: 12px;"> -->


				<p>全选</p>
			</div>
			<div class="uncollect cursor" @click="qxCollect">
				取消收藏
			</div>
		</div>
	</div>
	<!-- 取消收藏提示 -->
	<el-dialog title="" :visible.sync="dialogOut" width="25%">
		<div class="flex-1 jus-bet">
			<div></div>
			<div>
				<div class="flex-1 jus-bet">
					<div></div>
					<div class="flex-1 tan-1">
						<img src="../assets/myself/tixing.png" alt="">
						<p>确定取消收藏吗?</p>
					</div>
					<div></div>
				</div>
				<div class="tishis flex-1">
					<p @click="dialogOut = false">取消</p>
					<p @click="handleLogout">确定</p>
				</div>
			</div>
			<div></div>
		</div>
	</el-dialog>
	</div>
</template>
<script>
	import Breadcrumb from '@/views/Breadcrumb.vue';
	import footers from '@/views/footers.vue';
	import city from '@/components/city.json';
	import {
		getExpert,
		getTypes,
		getDeleteCollect,
		getMyExpert

	} from '@/api/expert/api.js';
	import {
		getCollect
	} from '@/api/collect/api.js';
	import {
		getUser
	} from '@/api/api.js';
	export default {
		components: {
			Breadcrumb,
			footers
		},
		props: {
			parentmsg: ''
		},
		data() {
			return {
				isSticky: false,
				stickyOffset: 0,
				scrollTop: 0,
				proviceList: city.data,
				num: 0,
				school: [],
				schoolNo: 0,
				officl: [],
				offlNo: 0,
				goodat: [],
				goodlNo: 0,
				money: [],
				moneyNo: 0,
				isNo: [{
						name: '公益',
						checked: false,
						isPublicWelfare: true,
					},
					{
						name: '非公益',
						checked: false,
						isPublicWelfare: false,
					}
				],
				isNum: 0,
				expertList: [],
				selectName: '',
				value: '',
				options: [{
					value: '1',
					label: '姓名'
				}, {
					value: '2',
					label: '地区'
				}, {
					value: '3',
					label: '擅长领域'
				}],
				selectType: 1,
				shows1: true,
				showAllSelected: false,
				schoolShow: true,
				officlShow: true,
				goodShow: true,
				moneyShow: true,
				isNoShow: true,
				page: 1,
				limit: this.pageGroup.size,
				//分页对象
				pageInline: {
					tableSizes: this.pageGroup.sizes, //显示条数分组
					tableTotal: 10, // 默认数据总数
				},
				titles: '',
				provinceCodeList: [],
				educationStageList: [],
				subjectList: [],
				fieldList: [],
				remunerationRangeList: [],
				isPublicWelfare: '',
				isIndex: -1,
				imgNv: require('@/assets/expert/nv.png'),
				imgNan: require('@/assets/expert/nan.png'),

				img1: require("@/assets/expert/shoucang.png"),
				img2: require("@/assets/expert/quxiao.png"),
				isShow1: false,
				nums: 0,
				showsAll: false,
				img3: require("@/assets/expert/weigou.png"),
				img4: require("@/assets/expert/gouxuan.png"),
				status: '',
				seachType: '',
				dialogOut: false,
				userList: {},
				hasFilter: false
			}
		},

		computed: {},

		created() {
			if (this.$route.fullPath == '/collect/index' || this.$route.fullPath == '/personal/collect/index') {
				this.titles = '收藏专家';
				this.status = 1;
			} else if (this.$route.fullPath == '/expert/wisdom') {
				this.titles = '专家智库';
				this.status = 0;
			} else if (this.$route.fullPath == '/personal/index') {
				this.titles = '我的专家';
				this.status = 2;
			} else if (this.$route.fullPath == '/personal/unlockedExperts') {
				this.titles = '我的专家';
				this.status = 2;
			}

		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll);
			this.stickyOffset = this.$el.querySelector('.boxshow').offsetTop;
				
			this.showAllSelected = true;

			this.seachType = this.$route.params.seachType;
			
			if (this.$route.params.selectName) {
				this.selectName = this.$route.params.selectName
			}

			
			let newarr1 = [];
			let list = this.proviceList;
			list.map((item, index) => {
				newarr1.push(Object.assign(item, {
					checked: false
				}))
			})

			// console.log(this.titles,'this.titles')
			// list = newarr1;
			// console.log(this.$route.fullPath,'地址栏')
		},
		beforeDestroy() {
		    window.removeEventListener('scroll', this.handleScroll);
		},
		watch: {
			'$root.searchText'(val) {
				this.educationStageList = '';
				this.subjectList = '';
				this.fieldList = '';
				this.remunerationRangeList = '';
				this.isIndex = -1;
				this.isPublicWelfare = '';
				this.isNoShow = true;
				this.isNum = 0;
				this.checkAll(false);
				this.schoCheckAll(false);
				this.officlCheckAll(false);
				this.goodCheckAll(false);
				this.moneyCheckAll(false);
				this.getInits(val);
			},
			chartsData: {
				handler(newVal, oldVal) {
					// 调用函数
					this.$nextTick(() => {
						this.getData()
					})
				},
				immediate: true,
				deep: true,
			},
			'$data': {
				handler: function(newVal, oldVal) {
					if (this.isPublicWelfare || this.educationStageList.length > 0 || this.value || this
						.provinceCodeList.length > 0 || this.subjectList.length > 0 || this.fieldList.length > 0 || this
						.remunerationRangeList.length > 0) {
							this.hasFilter = true
						}else{
							this.hasFilter = false
						}
				},
				immediate: true,
				deep: true
			}
		},
		activated() {
			if(window.previousRoute!=null && ['expertDetail'].includes(window.previousRoute.name)) {
				let data = window.localStorage.getItem("data")
				data = JSON.parse(data)
				for(let key in data) {
					this.$data[key] = data[key]
				}
				this.getInit(this.status, true)
			}else{
				this.getType();
				this.getMyUser();
			}
		},
		methods: {
			checkFilterVisible() {
			  var rect = document.getElementsByClassName('check')[0].getBoundingClientRect();
			  const isVisible = (rect.bottom > 0)
			  if (isVisible==false) {
				  this.shows1 = false
			  }
			},
			handleScroll() {
				if (this.shows1==false) {
					this.isSticky = window.scrollY >= this.stickyOffset;
				}
				this.scrollTop = window.scrollY
				this.checkFilterVisible()
			},
			getMyUser() {
				getUser().then(res => {
					if (res.code == 0) {
						this.userList = res.data;
					}
				})
			},
			collet(val) {
				if (val === 1) {
					this.isShow1 = !this.isShow1;
					this.nums = 1;
				}
			},
			// 收藏全选
			scCheckAll() {
				this.showsAll = !this.showsAll
				this.expertList.forEach((item) => {
					item.checked = this.showsAll
				})
				this.allList = this.expertList;
			},
			// 取消收藏
			qxCollect() {
				this.dialogOut = true;
			},
			// 取消收藏
			handleLogout() {
				let arr = [];
				this.allList.forEach((item, index) => {
					arr.push(item.id);
				})
				console.log(arr, '===')
				let params = {
					ids: arr.join(',')
				}
				getDeleteCollect(params).then(res => {
						console.log(res, '--')
						if (res.code == 0) {
							this.getInit(this.status)
							this.dialogOut = false;
							// this.details.collectStatus = false;
							// this.scShow = false;
						}
					})
					.catch(error => {

					});
			},
			getData() {
				if (this.parentmsg == 2) {
					this.isIndex = 0;
					this.isNoShow = false;
				} else if (this.parentmsg == 3 || this.parentmsg == 4) {
					this.schoolShow = false;
				}
			},
			getInits(selectName) {
				let params = {
					// type: 1,
					pageNo: this.page,
					pageSize: this.pageGroup.size,
					selectType: 1,
					selectName: selectName,
					provinceCodeList: this.provinceCodeList,
					educationStageList: this.educationStageList,
					subjectList: this.subjectList,
					fieldList: this.fieldList,
					remunerationRangeList: this.remunerationRangeList,
					isPublicWelfare: this.isPublicWelfare,
				}
				this.shows1 = false
				getExpert(params).then(res => {
						this.pageInline.tableTotal = res.data.total;
						let newarr1 = [];
						let list = res.data.list;
						list.map((item, index) => {
							newarr1.push(Object.assign(item, {
								checked: false
							}))
						})
						this.expertList = newarr1;
					})
					.catch(error => {

					});
			},
			getInit(status, scroll=false) {
				let params = {
					// type: 1,
					pageNo: this.page,
					pageSize: this.pageGroup.size,
					selectType: this.selectType,
					selectName: this.selectName,
					provinceCodeList: this.provinceCodeList,
					educationStageList: this.educationStageList,
					subjectList: this.subjectList,
					fieldList: this.fieldList,
					remunerationRangeList: this.remunerationRangeList,
					isPublicWelfare: this.isPublicWelfare,
				}
				this.shows1 = false
				if (status == 0) {
					getExpert(params).then(res => {
							this.pageInline.tableTotal = res.data.total;
							let newarr1 = [];
							let list = res.data.list;
							list.map((item, index) => {
								newarr1.push(Object.assign(item, {
									checked: false
								}))
							})
							this.expertList = newarr1;
							if (scroll) {
								window.scrollTo(0, this.scrollTop)
							}
						})
						.catch(error => {

						});
				} else if (status == 1) {
					getCollect(params).then(res => {
							this.pageInline.tableTotal = res.data.total;
							let newarr1 = [];
							let list = res.data.list;
							list.map((item, index) => {
								newarr1.push(Object.assign(item, {
									checked: false
								}))
							})
							this.expertList = newarr1;
							if (scroll) {
								window.scrollTo(0, this.scrollTop)
							}
						})
						.catch(error => {

						});
				} else if (status == 2) {
					getMyExpert(params).then(res => {
							this.pageInline.tableTotal = res.data.total;
							let newarr1 = [];
							let list = res.data.list;
							list.map((item, index) => {
								newarr1.push(Object.assign(item, {
									checked: false
								}))
							})
							this.expertList = newarr1;
							if (scroll) {
								window.scrollTo(0, this.scrollTop)
							}
						})
						.catch(error => {

						});
				}
			},
			getType() {
				this.educationStageList = [];
				getTypes().then(res => {
					let arr1 = [];
					let arr2 = [];
					let arr3 = [];
					let arr4 = [];
					let list = res.data;
					let newarr = [];
					list.map((item, index) => {
						newarr.push(Object.assign(item, {
							checked: false
						}))
					})
					list.forEach((item, index) => {
						if (item.type == 1) {
							arr1.push(item)
						} else if (item.type == 2) {
							arr2.push(item)
						} else if (item.type == 3) {
							arr3.push(item)
						} else if (item.type == 4) {
							arr4.push(item)
						}
					})

					//学科预处理
					for (let i = 0; i < arr1.length; i++) {
						if (this.parentmsg == 3 && arr1[i].name.indexOf('大学') != -1) {
							arr1[i].checked = true;
							this.educationStageList.push(arr1[i].id);
						} else if (this.parentmsg == 4 && ['学前名师','小学名师','初中名师','高中名师','教研员'].includes(arr1[i].name)) {
							arr1[i].checked = true;
							this.educationStageList.push(arr1[i].id);
						}
					}
					//公益预处理
					if (this.parentmsg == 2) {
						this.isPublicWelfare = true
					}
					this.educationStageList = this.educationStageList.join(',')
					this.school = arr1;
					this.officl = arr2;
					this.goodat = arr3;
					this.money = arr4;
					this.getInit(this.status);
				})
				
			},
			shou() {
				// console.log(11)
				this.shows1 = false;
			},
			checks() {
				this.shows1 = true;
				document.documentElement.scrollTop = 200
				document.body.scrollTop = 200
			},
			//页容量改变时会触发
			handleSizeChange(size) {
				this.pageGroup.size = size;
				this.limit = size;
				this.getInit(this.status);
			},
			//当前页改变时会触发
			handleCurrentChange(currentPage) {
				console.log(currentPage, 'currentPage')
				this.page = currentPage;
				this.getInit(this.status);
			},
			hancleClick(value) {
				console.log(value, 'value')
			},
			// 联系专家
			lixnai(item) {
				this.$router.push({
					name: 'expertDetail',
					params: {
						id: item.id
					}
				})
			},
			// 专家详情
			expertDetail(id, index, nums) {
				console.log(nums, '------')
				if (nums == 0 && this.status !== 1) {
					window.localStorage.setItem('data',JSON.stringify(this.$data))
					this.$router.push({
						name: 'expertDetail',
						params: {
							id: id
						}
					})
					// this.$router.push('/expert/expertDetail')
				} else if (nums == 1) {
					// console.log(this.expertList,'this.expertList测试')
					this.expertList[index].checked = !this.expertList[index].checked;
					// 每次点击判断是否全部选中，将状态赋值给
					let isSelectedAll = this.expertList.every((item) => item.checked);
					// console.log(isSelectedAll, 'isSelectedAll')
					this.showsAll = isSelectedAll;
					let data = this.expertList.filter((item) => item.checked)
					console.log(data, 'data')
					this.allList = data;
				}
			},
			// 省份
			proClick(index) {
				this.proviceList[index].checked = !this.proviceList[index].checked;
				let isSelectedAll = this.proviceList.every((item) => item.checked)
				this.showAllSelected = isSelectedAll
				let data = this.proviceList.filter((item) => item.checked)
				this.num = data.length;
				if (data.length == []) {
					this.showAllSelected = true;
				} else if (data.length < this.proviceList.length) {
					this.showAllSelected = false;
				} else {
					this.showAllSelected = true;
				}
				let arr = []
				data.forEach((item, index) => {
					arr.push(item.provinceCode)
				})
				this.provinceCodeList = arr.join(",")
				this.getInit(this.status)
			},
			checkAll(req = true) {
				this.showAllSelected = false;
				this.proviceList.forEach((item) => {
					item.checked = this.showAllSelected
				})
				let data = this.proviceList.filter((item) => item.checked)
				this.num = data.length;
				if (data.length == []) {
					this.showAllSelected = true;
				}
				// let arr = []
				// data.forEach((item, index) => {
				//     let ids = item.provinceCode
				//     arr.push(ids)
				// })
				// this.provinceCodeList = arr.join(",");
				this.provinceCodeList = '';
				if (req) {
					this.getInit(this.status)
				}
				// console.log(this.provinceCodeList,'this.provinceCodeList')
			},
			// 学段
			schoClick(name, index) {
				this.school[index].checked = !this.school[index].checked;
				let isSelectedAll = this.school.every((item) => item.checked)
				this.schoolShow = isSelectedAll
				let data = this.school.filter((item) => item.checked)
				// educationStageList
				// console.log(data, 'data')
				this.schoolNo = data.length;
				if (data.length == []) {
					this.schoolShow = true;
				} else if (data.length < this.school.length) {
					this.schoolShow = false;
				} else {
					this.schoolShow = true;
				}

				let arr = []
				data.forEach((item, index) => {
					let ids = item.id
					arr.push(ids)
				})


				this.educationStageList = arr.join(",");
				this.getInit(this.status)
			},
			schoCheckAll(req = true) {
				this.schoolShow = false;
				this.school.forEach((item) => {
					item.checked = this.schoolShow
				})
				let data = this.school.filter((item) => item.checked)
				this.schoolNo = data.length;
				if (data.length == []) {
					this.schoolShow = true;
				}
				// let arr = []
				// data.forEach((item, index) => {
				//     let ids = item.id
				//     arr.push(ids)
				// })
				this.educationStageList = '';
				if (req) {
					this.getInit(this.status)
				}
			},
			// 学科
			offClick(index) {
				this.officl[index].checked = !this.officl[index].checked;
				let isSelectedAll = this.officl.every((item) => item.checked)
				this.officlShow = isSelectedAll
				let data = this.officl.filter((item) => item.checked)
				this.offlNo = data.length;
				if (data.length == []) {
					this.officlShow = true;
				} else if (data.length < this.officl.length) {
					this.officlShow = false;
				} else {
					this.officlShow = true;
				}
				let arr = []
				data.forEach((item, index) => {
					let ids = item.id
					arr.push(ids)
				})
				this.subjectList = arr.join(",");
				this.getInit(this.status)
			},
			officlCheckAll(req = true) {
				this.officlShow = false;
				this.officl.forEach((item) => {
					item.checked = this.officlShow;
				})
				let data = this.officl.filter((item) => item.checked);
				this.offlNo = data.length;
				if (data.length == []) {
					this.officlShow = true;
				}
				// let arr = []
				// data.forEach((item, index) => {
				//     let ids = item.id
				//     arr.push(ids)
				// })
				this.subjectList = '';
				if (req) {
					this.getInit(this.status)
				}
			},
			// 擅长领域
			goodClick(index) {
				this.goodat[index].checked = !this.goodat[index].checked;
				let isSelectedAll = this.goodat.every((item) => item.checked)
				this.goodShow = isSelectedAll
				let data = this.goodat.filter((item) => item.checked)
				this.goodlNo = data.length;
				if (data.length == []) {
					this.goodShow = true;
				} else if (data.length < this.goodat.length) {
					this.goodShow = false;
				} else {
					this.goodShow = true;
				}
				let arr = []
				data.forEach((item, index) => {
					let ids = item.id
					arr.push(ids)
				})
				this.fieldList = arr.join(",");
				this.getInit(this.status)
			},
			goodCheckAll(req = true) {
				this.goodShow = false;
				this.goodat.forEach((item) => {
					item.checked = this.goodShow
				})
				let data = this.goodat.filter((item) => item.checked)
				this.goodlNo = data.length;
				if (data.length == []) {
					this.goodShow = true;
				}
				// let arr = []
				// data.forEach((item, index) => {
				//     let ids = item.id
				//     arr.push(ids)
				// })
				this.fieldList = '';
				if (req) {
					this.getInit(this.status)
				}
			},
			// 课酬区间
			moneyClick(index) {
				this.money[index].checked = !this.money[index].checked;
				let isSelectedAll = this.money.every((item) => item.checked)
				this.moneyShow = isSelectedAll
				let data = this.money.filter((item) => item.checked)
				this.moneyNo = data.length;
				if (data.length == []) {
					this.moneyShow = true;
				} else if (data.length < this.money.length) {
					this.moneyShow = false;
				} else {
					this.moneyShow = true;
				}
				let arr = []
				data.forEach((item, index) => {
					let ids = item.id
					arr.push(ids)
				})
				this.remunerationRangeList = arr.join(",");
				this.getInit(this.status)
			},
			moneyCheckAll(req = true) {
				this.moneyShow = false;
				this.money.forEach((item) => {
					item.checked = this.moneyShow
				})
				let data = this.money.filter((item) => item.checked)
				this.moneyNo = data.length;
				if (data.length == []) {
					this.moneyShow = true;
				}
				// let arr = []
				// data.forEach((item, index) => {
				//     let ids = item.id
				//     arr.push(ids)
				// })
				// this.remunerationRangeList = arr.join(",");
				this.remunerationRangeList = '';
				if (req) {
					this.getInit(this.status)
				}
			},
			// 是否公益
			isNoClick(index) {
				this.isIndex = index;
				this.isNo[index].checked = !this.isNo[index].checked;
				if (index == 0) {
					this.isPublicWelfare = true;
					this.isNoShow = false;
				} else {
					this.isPublicWelfare = false;
					this.isNoShow = false;
				}
				this.getInit(this.status)
				this.isNum = 1







				// let isSelectedAll = this.isNo.every((item) => item.checked)
				// this.isNoShow = isSelectedAll
				// let data = this.isNo.filter((item) => item.checked)
				// this.isNum = data.length;
				// if (data.length == []) {
				//     this.isNoShow = true;
				// } else if (data.length < this.isNo.length) {
				//     this.isNoShow = false;
				// } else {
				//     this.isNoShow = true;
				// }
				// let arr = []
				// data.forEach((item, index) => {
				//     let ids = item.id
				//     arr.push(ids)
				// })
				// this.isPublicWelfare = arr.join(",");
				// this.getInit(this.status)
			},
			isNoCheckAll(req = true) {
				this.isNoShow = true;
				// console.log(this.parentmsg)
				// if(this.parentmsg == 2){
				//     this.isNoShow = true;
				// }
				// if(this.parentmsg){
				//     this.isNoShow = true;
				// }else{
				//     this.isIndex = -1;
				//     this.isPublicWelfare = null;
				// }
				this.isIndex = -1;
				this.isPublicWelfare = null;
				if (req) {
					this.getInit(this.status)
				}

				this.isNum = 0;
				// this.isNoShow = !this.isNoShow
				// this.isNo.forEach((item) => {
				//     item.checked = this.isNoShow
				// })
				// let data = this.isNo.filter((item) => item.checked)
				// this.isNum = data.length;
				// if (data.length == []) {
				//     this.isNoShow = true;
				// }
				// let arr = []
				// data.forEach((item, index) => {
				//     let ids = item.id
				//     arr.push(ids)
				// })
				// this.isPublicWelfare = arr.join(",");
				// this.getInit(this.status)
			},
			selectChange(e) {
				console.log(e, '---')
				this.selectType = e;
			},
			again() {
				this.educationStageList = '';
				this.subjectList = '';
				this.fieldList = '';
				this.remunerationRangeList = '';
				this.isIndex = -1;
				this.isPublicWelfare = '';
				this.isNoShow = true;
				this.isNum = 0;
				this.checkAll(false);
				this.schoCheckAll(false);
				this.officlCheckAll(false);
				this.goodCheckAll(false);
				this.moneyCheckAll(false);
				this.getInit(this.status);
			}

		}
	}
</script>

<style scoped>
	.tan-1 {
		font-size: 20px;
		font-weight: 500;
		margin-bottom: 50px;
	}

	.expert {
		padding: 0 19%;
		/* margin-bottom: 100px; */
	}

	.boxshow {
		box-shadow: 0px 2px 8px 0px rgba(195, 219, 255, 0.25);
		border-radius: 8px 8px 8px 8px;
		background: #fff;
		padding-bottom: 10px;
	}

	.pad-16 {
		padding: 16px;
	}

	.flex-1 {
		display: flex;
		align-items: center;
	}

	.experts {

		margin-top: 16px;

	}

	.experts p {
		font-size: 20px;
		color: #222222;
		padding-left: 10px;
	}



	.check {
		/* width: 100%; */
		/* height: 352px; */
		background: #FAFAFA;
		border-radius: 4px 4px 4px 4px;
		color: #222222;
	}

	.check-1 {
		display: flex;
		/* align-items: center; */
		margin-bottom: 16px;
	}

	.check-1 p {
		padding: 4px 12px;
		font-size: 14px;
		margin: 0 5px 8px 0;
		white-space: nowrap;
	}

	.check-1-p {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}

	.check-1-p p:first-child {
		/* color: #3377FF;
        background: #F0F5FF;
        border-radius: 8px 8px 8px 8px; */
	}

	.check-p {
		/* margin-right: 24px; */
		min-width: 74px;
	}

	.jus-bet {
		justify-content: space-between;
	}

	.align-1 {
		align-items: center;
	}

	.shouqi {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		color: #666666;
	}

	.shouqi span {
		padding-right: 8px;
	}

	.search-2 {
		display: flex;
		border: 1px solid #EFEFEF;
		border-radius: 8px;
		margin: 24px;
	}

	.search-3 {
		display: flex;
		width: 100%
	}

	/deep/.elinput .el-input__inner {
		width: 100%;
		font-size: 14px;
	}

	/deep/.elinput .el-input__inner::placeholder {
		color: #cccccc;
	}

	/deep/.el-select .el-input .el-select__caret {
		color: #222222;
	}

	/deep/.place .el-input__inner::placeholder {
		color: #222222;
	}

	/deep/.place {
		/* width: 80px; */
	}

	/deep/.el-input .el-input__inner {
		border-radius: 0;
		border: 0;
		background-color: rgba(0, 0, 0, 0);
		/* width: 80px; */
		font-size: 14px;

	}

	.col-22 {
		color: #222222;

	}

	.hed-img {
		width: 10rem;
		height: 10rem;
		margin-right: 1rem;
		border-radius: 8px;
	}

	.sex-img {
		width: 14px;
		height: 14px;
	}

	.online {
		font-size: 14px;
		color: #3377FF;
		padding: 8px 16px;
		background: #F0F5FF;
		white-space: nowrap;
		border-radius: 35px 35px 35px 35px;
		white-space: nowrap;
	}

	.mb-8 {
		margin-bottom: 8px;
	}

	.name-1 {
		font-size: 20px;
		padding-right: 9px;
	}

	.name-2 {
		color: #999999;
		font-size: 14px;
		white-space: nowrap;
		padding-right: 8px;
	}

	.name-3 {
		font-size: 14px;
		font-weight: normal;
	}

	/deep/.el-pagination {
		text-align: center;
	}

	.footers {
		margin-top: 25px !important;
	}

	.selected {
		color: #3377FF;
		background: #F0F5FF;
		border-radius: 8px 8px 8px 8px;
	}

	.delAll {
		color: #222222;
	}

	.el-button--primary {
		border-radius: 0 8px 8px 0;
		background-color: #3377FF;
	}

	.mt {
		margin-top: 0;
	}

	.colet {
		color: #3377FF !important;
	}

	.colet-1 {

		color: #222222;
	}

	.clool {
		border: 1px solid #3377FF;
		border-radius: 4px;
		padding: 18px;
	}

	.clool-1 {
		border: 1px solid #EFEFEF;
		border-radius: 4px;
		padding: 18px;
	}

	.clool-2 {
		border: 0;
		border-radius: 0;
		padding: 0;
	}

	.checkall {
		border-top: 1px solid #EFEFEF;
		padding: 16px 0 0 16px;
		margin-top: 26px;
	}

	.uncollect {
		font-size: 14px;
		color: #FFFFFF;
		padding: 8px 16px;
		background: #3377FF;
		border-radius: 35px 35px 35px 35px;
	}

	.quanxuan p {
		color: #222222;
		font-size: 14px;
	}

	.tishis p {
		font-size: 16px;
		padding: 12px 44px;
		border-radius: 4px 4px 4px 4px;
	}

	.tishis p:first-child {
		color: #666666;
		background-color: #EFEFEF;
		margin-right: 2.5rem;
	}

	.tishis p:last-child {
		color: #FFFFFF;
		background-color: #3377FF;
	}
	
	.sticky {
	  position: sticky;
	  top: 0;
	}
</style>